/* eslint-disable @typescript-eslint/no-explicit-any */
import classNames from 'classnames';
import { DOPIcon } from 'components/1-atoms/Media';
import { useEffect, useState } from 'react';
import styles from './DatePickerCustomHeader.module.scss';

type DatePickerCustomHeaderAriaLabelsType = {
	prevBtnAriaLabel: string;
	nextBtnAriaLabel: string;
};

export type YearOptionsType = {
	startYear: number;
	endYear: number;
};

//TODO all the any's are the values that ReactDatePicker uses
export interface DatePickerCustomHeaderProps {
	date: any;
	changeYear: any;
	changeMonth: any;
	decreaseMonth: any;
	increaseMonth: any;
	prevMonthButtonDisabled: any;
	nextMonthButtonDisabled: any;
	locale: string;
	ariaLabels: DatePickerCustomHeaderAriaLabelsType;
	enableMonthSelect: boolean;
	enableYearSelect: boolean;
	yearOptions: YearOptionsType;
}

export const DatePickerCustomHeader = ({
	date,
	changeYear,
	changeMonth,
	decreaseMonth,
	increaseMonth,
	prevMonthButtonDisabled,
	nextMonthButtonDisabled,
	locale,
	ariaLabels,
	enableMonthSelect,
	enableYearSelect,
	yearOptions,
}: DatePickerCustomHeaderProps) => {
	const yearRange = (start, end) => {
		const length = end - start + 1;
		return Array.from({ length }, (_, i) => start + i);
	};

	const [months, setMonths] = useState<string[]>(
		Array.from(Array(12), (_, index) => new Date(2000, index, 1).toLocaleString(locale, { month: 'long' })),
	);
	const [years, setYears] = useState<number[]>(
		enableYearSelect && yearOptions ? yearRange(yearOptions.startYear, yearOptions.endYear).reverse() : undefined,
	);

	useEffect(() => {
		if (enableYearSelect && yearOptions) {
			setYears(yearRange(yearOptions.startYear, yearOptions.endYear).reverse());
		}
	}, [enableYearSelect, yearOptions]);

	useEffect(() => {
		if (enableMonthSelect) {
			setMonths(Array.from(Array(12), (_, index) => new Date(2000, index, 1).toLocaleString(locale, { month: 'long' })));
		}
	}, [enableMonthSelect, locale]);

	return (
		<div className={styles.DatePickerCustomHeader}>
			<button
				className={classNames(styles.DatePickerCustomHeader_prevBtn, styles.DatePickerCustomHeader_btn)}
				onClick={decreaseMonth}
				disabled={prevMonthButtonDisabled}
				type="button"
				aria-label={ariaLabels.prevBtnAriaLabel}
			>
				<DOPIcon name="ArrowLeft" size="sm" />
			</button>
			{enableMonthSelect && months ? (
				<select
					className={styles.DatePickerCustomHeader_select}
					value={months[date.getMonth()]}
					onChange={({ target: { value } }) => changeMonth(months.indexOf(value))}
				>
					{months.map((option) => (
						<option key={option} value={option}>
							{option}
						</option>
					))}
				</select>
			) : (
				<p className={styles.DatePickerCustomHeader_text}>{months[date.getMonth()]}</p>
			)}
			{enableYearSelect && years ? (
				<select
					className={styles.DatePickerCustomHeader_select}
					value={date.getFullYear()}
					onChange={({ target: { value } }) => changeYear(value)}
				>
					{years.map((option) => (
						<option key={option} value={option}>
							{option}
						</option>
					))}
				</select>
			) : (
				<p className={styles.DatePickerCustomHeader_text}>{date.getFullYear()}</p>
			)}

			<button
				className={classNames(styles.DatePickerCustomHeader_nextBtn, styles.DatePickerCustomHeader_btn)}
				onClick={increaseMonth}
				disabled={nextMonthButtonDisabled}
				type="button"
				aria-label={ariaLabels.nextBtnAriaLabel}
			>
				<DOPIcon name="ArrowRight" size="sm" />
			</button>
		</div>
	);
};
